// CognatesTab.jsx
import React from "react";
import { EnterOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { Input as InputArea } from "antd";
import { Add, Delete } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import Loading from "components/Loading";
import { get, map } from "lodash";
import styled from "styled-components";
import AnimatedCheckMark from "components/AnimatedCheckMark";
import AnimatedCross from "components/AnimatedCross";
import { dispalayRole } from "utils/methods/math";

const CognatesTab = ({
  vocabularyData,
  showWordLoader,
  callVocAI,
  handleAddVocData,
  editDataProperty,
  handleUpdateData,
  addNewItem,
  setDeleteModal,
  setDeleteVocab,
  showWordEnglishLoader,
  from = {},
}) => {
  return (
    <StyledTable border className="vocabulTable">
      <StyledHeader className="vocabulHeadTh">
        <StyledTh style={{ maxWidth: 250 }}>Cognate</StyledTh>
        <StyledTh>Word (Spanish)</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Word (English)</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Type</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Explanation</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Sentence in Spanish</StyledTh>
        <StyledTh style={{ minWidth: 200 }}>Sentence in English</StyledTh>
        <StyledTh>Actions</StyledTh>
      </StyledHeader>

      {map(vocabularyData, (value, k) => {
        let data = get(value, "data", "");
          const roleDisplay =
          from?.from === 'admin' && from?.page === 'edit-resource'
            ? `(${dispalayRole(value?.created_by)})`
            : from?.from === 'admin' && from?.page === 'inapporiate-word'
              ? `(Admin)`
              : ``;
        return (
          <tr className="vocabulHeadTr vocIcons" key={k}>
            <td style={{ textAlign: "center" }}>
              {data?.word_spanish && (
                <div
                  onClick={() => {
                    editDataProperty(value.id, !data?.type, "type");
                    handleUpdateData(value);
                  }}
                  className="flex items-center justify-center"
                >
                  {data?.type ? (
                    <AnimatedCheckMark animation={false} />
                  ) : (
                    <AnimatedCross animation={false} />
                  )}
                </div>
              )}
            </td>

            {/*  *** for  word  spanish**** */}
            <td style={{ textAlign: "center" }}>
              {value?.isEditable === true && !showWordEnglishLoader ? (
                <div style={{ position: "relative" }}>
                  <InputArea
                    onPressEnter={() => {
                      if (!showWordLoader) {
                        callVocAI("spanish");
                      }
                    }}
                    onChange={(d) => {
                      handleAddVocData("word", d.target.value.trimStart());
                    }}
                    placeholder="Word Spanish"
                    autoSize
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "white",
                      fontWeight: 200,
                      width: vocabularyData?.length === 1 && "160px",
                    }}
                  />
                  <div style={{ position: "absolute", top: 6, right: 4 }}>
                    {showWordLoader ? (
                      <Loading size={17} />
                    ) : (
                      <EnterOutlined
                        disabled={showWordLoader}
                        onClick={() => {
                          if (!showWordLoader) {
                            callVocAI("spanish");
                          }
                        }}
                        style={{ fontSize: "25px" }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <TextArea
                    value={get(data, "word_spanish", "") + `${roleDisplay}`}
                    onChange={(d) =>
                      editDataProperty(
                        value.id,
                        d.target.value.trimStart(),
                        "word_spanish"
                      )
                    }
                    placeholder="word spanish"
                    autoSize
                    style={{
                      width: 150,
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "white",
                      fontWeight: 200,
                    }}
                  />
                </>
              )}
            </td>

            {/*  *** for  word_english **** */}
            <td style={{ textAlign: "center" }}>
              {value?.isEditable === true && !showWordLoader ? (
                <div style={{ position: "relative" }}>
                  <InputArea
                    onPressEnter={() => {
                      if (!showWordEnglishLoader) {
                        callVocAI("english");
                      }
                    }}
                    onChange={(d) => {
                      handleAddVocData("word", d.target.value.trimStart());
                    }}
                    placeholder="Word English"
                    autoSize
                    style={{
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "white",
                      fontWeight: 200,
                      width: vocabularyData?.length === 1 && "160px",
                    }}
                  />
                  <div style={{ position: "absolute", top: 6, right: 4 }}>
                    {showWordEnglishLoader ? (
                      <Loading size={17} />
                    ) : (
                      <EnterOutlined
                        disabled={showWordEnglishLoader}
                        onClick={() => {
                          if (!showWordEnglishLoader) {
                            callVocAI("english");
                          }
                        }}
                        style={{ fontSize: "25px" }}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <>
                  <TextArea
                    value={get(data, "word_english", "") + `${roleDisplay}`}
                    onChange={(d) =>
                      editDataProperty(
                        value.id,
                        d.target.value.trimStart(),
                        "word_english"
                      )
                    }
                    placeholder="word english"
                    autoSize
                    style={{
                      width: 150,
                      backgroundColor: "transparent",
                      borderColor: "transparent",
                      color: "white",
                      fontWeight: 200,
                    }}
                  />
                </>
              )}
            </td>

            {/*  *** for  type **** */}
            <td style={{ textAlign: "center" }}>
              {data?.word_spanish && (
                <TextArea
                  disabled={true}
                  value={data?.type ? "True Cognate" : "False Cognate"}
                  autoSize
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "transparent",
                    color: "white",
                    fontWeight: 200,
                    padding: 0,
                  }}
                />
              )}
            </td>

            {/*  *** for  Explanation **** */}
            <td style={{ textAlign: "center" }}>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, "explaination", "")}
                onChange={(d) =>
                  editDataProperty(
                    value.id,
                    d.target.value.trimStart(),
                    "explaination"
                  )
                }
                autoSize
                style={{
                  width: "200px",
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  color: "white",
                  fontWeight: 200,
                  padding: "0px",
                  height: "133.6px",
                  resize: "none",
                  marginTop: "12px",
                }}
              />
            </td>

            {/*  *** for  sentence in spanish **** */}
            <td style={{ textAlign: "center" }}>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, "sentence_spanish", "")}
                onChange={(d) =>
                  editDataProperty(
                    value.id,
                    d.target.value.trimStart(),
                    "sentence_spanish"
                  )
                }
                autoSize
                style={{
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  color: "white",
                  fontWeight: 200,
                  padding: 0,
                  marginTop: "12px",
                }}
              />
            </td>

            {/*  *** for  sentence in english **** */}
            <td style={{ textAlign: "center" }}>
              <TextArea
                onBlur={() => {
                  handleUpdateData(value);
                }}
                value={get(data, "sentence_english", "")}
                onChange={(d) =>
                  editDataProperty(
                    value.id,
                    d.target.value.trimStart(),
                    "sentence_english"
                  )
                }
                autoSize
                style={{
                  backgroundColor: "transparent",
                  borderColor: "transparent",
                  color: "white",
                  fontWeight: 200,
                  padding: 0,
                  marginTop: "12px",
                }}
              />
            </td>

            {/*  *** for  action **** */}
            <td style={{ textAlign: "center" }}>
              {data?.word_spanish && data?.word_english && (
                <Delete
                  style={{ fontSize: 20 }}
                  onClick={() => {
                    setDeleteVocab(value);
                    setDeleteModal(true);
                  }}
                />
              )}
            </td>
          </tr>
        );
      })}

      <tr className="vocabulHeadTr">
        <td></td>
        <td>
          <IconButton onClick={addNewItem}>
            <Add style={{ fontSize: "18px" }} />
          </IconButton>
        </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </StyledTable>
  );
};
export default CognatesTab;

const ActionText = styled.p`
  font-size: 14px;
  color: white;
  font-weight: 500;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 100vw;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  border-radius: 10px;
  background-color: #fff;
  padding: 10px;
  transform: translate(-50%, -50%);
  top: 50%;
  @media (max-width: 1366px) {
    width: 90vw;
  }

  @media (max-width: 500px) {
    max-height: 560px;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  overflow-y: auto;
  max-height: 550px;
  border-collapse: collapse;
  td {
    border: 0.5px solid #fff;
  }
  th {
    border: 0.5px solid #fff;
  }
`;

const StyledHeader = styled.tr`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 10;
`;
const StyledTh = styled.th`
  background: #5d4187;
  color: #ffffff;
`;
